import React, { Component } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import 'App.css';
import SignInPage from 'pages/signIn/SignInPage';
import TopTenPodcasts from 'pages/topTenPodcasts/TopTenPodcasts';
import PodcastsByLanguage from 'pages/podcastsByLanguage/PodcastsByLanguage';
import Trending from 'pages/trending/Trending';
import Podcast from 'pages/podcast/Podcast';
import SeeAll from 'pages/seeAll/SeeAll';
import AddPodcastPage from 'pages/addPodcast/addPodcastPage';
import ProfilePage from 'pages/profile/ProfilePage';
import UpdateProfilePage from 'pages/updateProfile/UpdateProfilePage';
import PodcastDetail from 'pages/podcastDetail/podcastDetail';
import EpisodePage from 'pages/episodePage/episodePage';
import HistoryPage from 'pages/history/HistoryPage';
import TermsAndConditionsPage from 'pages/termsAndConditions/TermsAndConditionsPage';
import PrivacyPolicyPage from 'pages/privacyPolicy/privacyPolicyPage';
import RewardHistoryPage from 'pages/rewardHistory/RewardHistoryPage';
import RedemptionPage from 'pages/redemption/RedemptionPage';
import LinkWallet from 'pages/linkWallet/linkWallet';
import AirDropHistoryPage from 'pages/airDropHistory/AirDropHistoryPage';
import ShopHistoryPage from 'pages/shopHistory/ShopHistoryPage';
import CoinbaseWallet from 'pages/coinbaseWallet/coinbaseWallet';
import MyWallet from 'pages/myWallet/myWallet';
import WebView from 'components/webview/webview';
import NetworkStatus from 'pages/network/NetworkStatus';
import { logEventWebsiteOpened, logEventLoggedIn } from 'utils/analytics';
import { auth } from 'utils/firebaseConfig';
import { ensureMusicEngineTokenForFirebaseUser, setMusicEngineAccessToken } from 'api/api';
import TopicSelector from 'pages/TopicSelector/TopicSelector';

export const UserContext = React.createContext();

class App extends Component {
  state = {
    user: null,
    showLoader: true,
    isLoginEventTracked: false
  };

  setShowLoader = (value) => {
    this.setState({ showLoader: value });
  };

  setFirebaseUser = async (newUser) => {
    this.setState({ showLoader: false, user: newUser });
    if (!newUser) {
      localStorage.removeItem('accessToken');
      // Clear MusicEngine token on logout
      setMusicEngineAccessToken(null);
    } else {
      try {
        const idToken = await newUser.getIdToken();
        if (!this.state.isLoginEventTracked) {
          logEventLoggedIn(newUser);
          this.setState({ isLoginEventTracked: true });
        }
        localStorage.setItem('accessToken', idToken);
        // Bridge to MusicEngine: ensure we have a MusicEngine token for this Firebase user
        await ensureMusicEngineTokenForFirebaseUser(newUser);
      } catch (error) {
        localStorage.removeItem('accessToken');
        setMusicEngineAccessToken(null);
      }
    }
  };

  async componentDidMount() {
    logEventWebsiteOpened(this.state.user);
    this.unsubscribe = auth.onAuthStateChanged(async (userObj) => {
      try {
        await this.setFirebaseUser(userObj || null);
      } catch (error) {
        await this.setFirebaseUser(null);
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  renderRoutes() {
    return (
      <Switch>
        <Route exact path='/'>
          <SignInPage showLoader={this.state.showLoader} setShowLoader={this.setShowLoader} />
        </Route>
        {/* /discover deprecated; keep temporarily if any legacy redirects rely on it */}
        <Route exact path='/home/topTenPodcasts' component={TopTenPodcasts} />
        <Route exact path='/home/podcastsByLanguage' component={PodcastsByLanguage} />
        <Route exact path='/podcast' component={Podcast} />
        <Route exact path='/trending' component={Trending} />
        <Route exact path='/podcastlist' component={SeeAll} />
        <Route exact path='/addPodcast' component={AddPodcastPage} />
        {/* /home/profile deprecated; redirect handled via settings */}
        <Route exact path='/updateprofile' component={UpdateProfilePage} />
        <Route path='/podcastdetail/:id' component={PodcastDetail} />
        <Route exact path='/episodePage/:id/:episode' component={EpisodePage} />
        <Route exact path='/history' component={HistoryPage} />
        <Route exact path='/rewards' component={RewardHistoryPage} />
        <Route exact path='/redemption' component={RedemptionPage} />
        <Route exact path='/terms' component={TermsAndConditionsPage} />
        <Route exact path='/privacy' component={PrivacyPolicyPage} />
        <Route exact path='/settings' component={ProfilePage} />
        <Route exact path='/shopHistory' component={ShopHistoryPage} />
        <Route exact path='/airDropHistory' component={AirDropHistoryPage} />
        <Route exact path='/linkwallet' component={LinkWallet} />
        <Route exact path='/webview/:url?' component={WebView} />
        <Route exact path='/coinbaseWallet' component={CoinbaseWallet} />
        <Route exact path='/mywallet/:code?' component={MyWallet} />
        <Route exact path='/topic-selector' component={TopicSelector} />
      </Switch>
    );
  }

  render() {
    return (
      <UserContext.Provider value={this.state.user}>
        <div className='App' style={{ position: 'relative' }}>
          <HashRouter>
            <NetworkStatus />
            {this.renderRoutes()}
          </HashRouter>
        </div>
      </UserContext.Provider>
    );
  }

}

export default App;
